import { Component, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter, SimpleChanges, ViewEncapsulation } from '@angular/core';

import { BehaviorSubject, Subject, Subscription } from 'rxjs';

import { AreaDrawerService } from '@commons/services/map/drawer/area/area-drawer.service';
import { AreaTypeEnum } from '@commons/enums/area-type.enum';

enum Step {
    Default = 1,
    TypeSelection = 2,
    Definition = 3
}


@Component({
    selector: 'tk-area-create',
    templateUrl: './area-create.component.html',
    styleUrls: ['./area-create.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class AreaCreateComponent implements OnInit, OnChanges, OnDestroy {

    @Output() public onCancel: EventEmitter<any> = new EventEmitter<any>();

    /**
     * When true component switches to definition view immediately
     */
    @Input() public goToDefinition: boolean = false;

    /**
      * Subject for selected area type communication: create area componenet -> form component
      */
    @Input() public selectedAreaTypeSubject?: BehaviorSubject<AreaTypeEnum | undefined>;


    /**
     * Subscription to saving done signal stream
     */
    private savingDoneSub?: Subscription;

    /**
     * Subject for pushing steps
     */
    public stepSubject: Subject<Step> = new Subject<Step>();

    /**
     * Subscription to stream of view mode changes
     */
    private stepSub?: Subscription;

    /**
     * Current step
     */
    public step: Step = Step.Default;

    /**
     * For template
     */
    public Step = Step;

    /**
     * Selected area type
     */
    public areaType?: AreaTypeEnum;

    /**
     * For template
     */
    public AreaTypeEnum = AreaTypeEnum;


    /**
    * Component constructor
    * @param $areaDrawer area drawer service
    */
    constructor(
        private $areaDrawer: AreaDrawerService
    ) { }


    /**
     * On init lifecycle hook
     */
    public ngOnInit(): void {

        // Subscribe for view mode changes and push area type
        this.stepSub = this.stepSubject.subscribe(step => {
            this.step = step;
            if (step === Step.Default || step === Step.Definition) {
                console.log(99, this.areaType);
                this.selectedAreaTypeSubject?.next(this.areaType!);
            }
        });

    }


    /**
     * On changes lifecycle hook
     */
    public ngOnChanges(changes: SimpleChanges): void {

        if (changes && changes['goToDefinition'] && changes['goToDefinition'].currentValue) {
            this.step = Step.Definition;
        } else {
            this.step = Step.Default;
        }
    }


    /**
     * On destroy lifecycle hook
     */
    public ngOnDestroy(): void {

        this.cancel();
        if (this.stepSub) {
            this.stepSub.unsubscribe();
        }
        if (this.savingDoneSub) {
            this.savingDoneSub.unsubscribe();
        }
    }


    /**
     * Switches to select area type mode
     */
    public addArea(): void {

        this.stepSubject.next(Step.TypeSelection);
    }


    /**
     * Cancels entire adding operation
     */
    public cancel(): void {

        this.areaType = undefined;
        this.stepSubject.next(Step.Default);

        this.onCancel.emit(null);
    }


    /**
     * Switches to adding mode according to given area type
     * @param actionType area type
     */
    public selectAreaType(areaType: AreaTypeEnum): void {
        this.areaType = areaType;
        this.stepSubject.next(Step.Definition);
    }
}
